export type GlasTyp = 'esg_klar' | 'milchglas' | 'bronzeglas' | 'grauglas';
export type RahmenFarbe = 'weiss' | 'weiss_9010' | 'silber' | 'anthrazit' | 'schwarz' | 'bronze' | 'wunsch_ral';
export type OeffnungsRichtung = 'links' | 'beidseitig' | 'rechts';
export type SpurenAnzahl = 2 | 3 | 4 | 5;

export interface KonfiguratorState {
  breite: number;
  hoehe: number;
  scheibenAnzahl: number;
  glasTyp: GlasTyp;
  rahmenFarbe: RahmenFarbe;
  spuren: SpurenAnzahl;
  oeffnungsRichtung: OeffnungsRichtung;
}

export interface GlasOption {
  id: GlasTyp;
  name: string;
  beschreibung: string;
  preisProM2: number;
  farbe: string;
  opacity: number;
}

export interface RahmenOption {
  id: RahmenFarbe;
  name: string;
  ral: string;
  aufpreis: number;
  hex: string;
}

export const GLAS_OPTIONEN: GlasOption[] = [
  {
    id: 'esg_klar',
    name: 'ESG Klarglas',
    beschreibung: '10mm Einscheiben-Sicherheitsglas, klar',
    preisProM2: 119,
    farbe: '#a8d8ea',
    opacity: 0.25,
  },
  {
    id: 'milchglas',
    name: 'Milchglas',
    beschreibung: '8mm ESG satiniert, Sichtschutz',
    preisProM2: 132,
    farbe: '#e8e8e8',
    opacity: 0.7,
  },
  {
    id: 'bronzeglas',
    name: 'Bronzeglas',
    beschreibung: '8mm ESG bronzefarben getönt',
    preisProM2: 156,
    farbe: '#8B6914',
    opacity: 0.35,
  },
  {
    id: 'grauglas',
    name: 'Grauglas',
    beschreibung: '8mm ESG grau getönt',
    preisProM2: 150,
    farbe: '#6b7280',
    opacity: 0.35,
  },
];

export const RAHMEN_OPTIONEN: RahmenOption[] = [
  { id: 'weiss',      name: 'Weiß',        ral: 'RAL 9016',      aufpreis: 0,   hex: '#f5f5f5' },
  { id: 'weiss_9010', name: 'Weiß',        ral: 'RAL 9010',      aufpreis: 0,   hex: '#fefefe' },
  { id: 'silber',    name: 'Silber',      ral: 'RAL 9006',      aufpreis: 80,  hex: '#a8a9ad' },
  { id: 'anthrazit', name: 'Anthrazit',   ral: 'RAL 7016',      aufpreis: 120, hex: '#383e42' },
  { id: 'schwarz',   name: 'Schwarz',     ral: 'RAL 9005',      aufpreis: 150, hex: '#0e0e10' },
  { id: 'bronze',    name: 'Bronzebraun', ral: 'RAL 8017',      aufpreis: 160, hex: '#4e3524' },
  { id: 'wunsch_ral',name: 'Wunsch RAL',  ral: 'RAL nach Wahl', aufpreis: 290, hex: 'wunsch'  },
];

export interface PreisAufschluesselung {
  basispreis: number;
  glasAufpreis: number;
  rahmenAufpreis: number;
  netto: number;
  mwst: number;
  brutto: number;
}

export function berechnePreis(cfg: KonfiguratorState): PreisAufschluesselung {
  const flaeche = (cfg.breite / 1000) * (cfg.hoehe / 1000);
  // 119 €/m² Glas-Basis + 48 €/m² Alu-Konstruktion + 590 € Fixbetrag + 5% + 3% Aufschlag (intern)
  const basispreis = (flaeche * (119 + 48) + 590) * 1.05 * 1.03;

  const glas = GLAS_OPTIONEN.find(g => g.id === cfg.glasTyp)!;
  const glasAufpreis = flaeche * (glas.preisProM2 - 119);

  const rahmen = RAHMEN_OPTIONEN.find(r => r.id === cfg.rahmenFarbe)!;
  const rahmenAufpreis = rahmen.aufpreis;

  const netto = basispreis + glasAufpreis + rahmenAufpreis;
  const mwst = netto * 0.19;
  const brutto = netto + mwst;

  return { basispreis, glasAufpreis, rahmenAufpreis, netto, mwst, brutto };
}

export const DEFAULT_CONFIG: KonfiguratorState = {
  breite: 3000,
  hoehe: 2200,
  scheibenAnzahl: 4,
  glasTyp: 'esg_klar',
  rahmenFarbe: 'anthrazit',
  spuren: 2,
  oeffnungsRichtung: 'beidseitig',
};
